/** Dhivehi labels for the Award Sheet PDF (official PR-03 V2 template, "ޖަދުވަލު 3"). */
export const AWARD_SHEET_FIELD_LABELS = {
    formReference: "ޖަދުވަލު 3 - PR-03",
    pdfDocumentTitle: "އެވޯޑް ޝީޓް / ނިންމުން",
    /** Followed by the sheet year, e.g. "ބިޑު ކޮމިޓީ 2025". */
    committeeYearTitle: "ބިޑު ކޮމިޓީ",
    date: "ތާރީޚް:",
    /** Time range suffix, e.g. "(13:00 14:00 އަށް)". */
    timeRangeSuffix: "އަށް",
    meetingNumber: "ޖަލްސާ ނަންބަރު:",
    tenderName: "މަޝްރޫޢުގެ ނަން:",
    location: "މަޝްރޫޢު ހިންގާ އޮފީސް:",
    tenderOrQuotationNumber: "ޓެންޑަރ / ކޮޓޭޝަން ނަންބަރު:",
    awardedVendor: "މަސައްކަތް ހަވާލުކުރަން ހުށަހަޅާ ފަރާތް:",
    tenderPrice: "މަސައްކަތް ނިންމަން ހުށަހަޅާ އަގު:",
    duration: "މަސައްކަތް ނިންމަން ހުށަހަޅާ މުއްދަތު:",
    daysSuffix: "ދުވަސް",
    decision: "ނިންމުން:",
    detail: "ތަފްސީލް:",
    acknowledgement: "އިޤްރާރު:",
    /** Used when the sheet has no acknowledgement text of its own. */
    acknowledgementDefault: "މަތީގައިވާ މަޝްރޫޢުއާއި ގުޅިގެން ހުށަހަޅާފައިވާ އެންމެހާ ލިޔެކިޔުންތައް ނޭޝަނަލް ޓެންޑަރ ބޯޑު/ ބިޑު ކޮމިޓީގައި މަޝްވަރާކޮށް ބަލައި ޗެކްކުރުމަށްފަހު، ދައުލަތުގެ މާލިއްޔަތުގެ ގަވާއިދާއި އެގަވާއިދުގެ ދަށުން ހަދާފައިވާ އުޞޫލުތަކާއި އެއްގޮތްވާ ގޮތުގެ މަތިން ފެންނަ /ނުފެންނަކަމަށް ނިންމާ ސޮއިކުރަމެވެ.",
    colMemberName: "މެމްބަރުންގެ ނަން",
    colOffice: "އޮފީސް/ އެހެނިހެން",
    colApproved: "ފެންނަ (ސޮއި)",
    colRejected: "ނުފެންނަ (ސޮއި)",
    /** Printed in the office column (members' offices aren't stored). */
    defaultOffice: "ހުޅުމާލެ ހޮސްޕިޓަލް",
    approved: "ފެންނަ",
    rejected: "ނުފެންނަ",
    chairPerson: "ބައްދަލުވުމުގެ ޗެއަރޕަރސަން:",
    secretary: "ބައްދަލުވުމުގެ ސެކްރެޓަރީ:",
    nameLabel: "ނަން:",
    signatureLabel: "ސޮއި:",
};
//# sourceMappingURL=awardSheetFieldLabels.js.map